export default __webpack_public_path__ + "static/media/welcome-poster.d807c36a.png";